import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO, { breadcrumbJsonLd, placesListJsonLd } from '../components/SEO';
import { locations } from '../data/locations';

export default function LocationsIndex() {
  const places = locations.map((l) => ({
    city: l.city,
    state: l.state,
    path: `/welding-electrodes-in/${l.slug}`,
  }));

  return (
    <div>
      <SEO
        title="Welding Electrode Suppliers Across India"
        description="Prakash Electrodes supplies IS 814:2004-certified welding electrodes across India — Rajasthan, Gujarat, Maharashtra, Punjab, MP and beyond. Find welding electrodes in your city."
        path="/welding-electrodes-in"
        keywords={[
          'welding electrode supplier India',
          'welding electrodes near me',
          'welding rods supplier',
        ]}
        jsonLd={[
          breadcrumbJsonLd([
            { name: 'Home', path: '/' },
            { name: 'Locations', path: '/welding-electrodes-in' },
          ]),
          placesListJsonLd(places),
        ]}
      />
      <Navbar />

      <section className="relative bg-[#0b0b0d] text-white pt-40 pb-24 overflow-hidden noise">
        <div className="absolute inset-0 bg-grid opacity-30" />
        <div className="absolute right-0 top-0 h-96 w-96 rounded-full bg-amber-500/20 blur-3xl" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-amber-400 mb-4">
            — Serving India
          </div>
          <h1 className="font-display text-4xl md:text-6xl font-semibold leading-[1.05] max-w-4xl">
            Welding electrodes, delivered across India
          </h1>
          <p className="mt-6 text-white/70 text-lg max-w-2xl">
            From our IS 814:2004-certified factory in Kota, we supply welders and
            industries nationwide. Find your city below.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {locations.map((l) => (
            <Link
              key={l.slug}
              to={`/welding-electrodes-in/${l.slug}`}
              className="group flex items-center justify-between rounded-2xl border border-stone-200 p-6 hover:border-amber-400 hover:shadow-sm transition-all"
            >
              <div className="flex items-center gap-3">
                <MapPin className="h-5 w-5 text-amber-500" />
                <div>
                  <div className="font-display font-semibold text-stone-900">
                    {l.city}
                  </div>
                  <div className="text-xs text-stone-500">{l.state}</div>
                </div>
              </div>
              <ArrowRight className="h-4 w-4 text-stone-400 group-hover:text-amber-500 group-hover:translate-x-1 transition-all" />
            </Link>
          ))}
        </div>
      </section>

      <Footer />
    </div>
  );
}
